import {EventEmitter, Injectable} from '@angular/core';
import {Artwork} from "../../models/artwork";
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {ArtworkCategory} from "../../models/artwork-category";

@Injectable({
    providedIn: 'root'
})
export class ArtworkService {

    public artwork: Artwork = null;
    public artworks: Array<Artwork> = [];
    public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private http: HttpClient,
    ) {
    }

    getAllMyArtworks(projectId, databaseId, orderBy = 'code') {
      const url = !!orderBy
        ? this.getPath(projectId, databaseId) + '?o=' + orderBy
        : this.getPath(projectId, databaseId);

        return this.http.get(url).pipe(
            tap(data => this.artworks = data['data']['artworks'])
        )
    }

    postArtwork(projectId, databaseId, name: string) {
        return this.http.post(this.getPath(projectId, databaseId), {name}).pipe(
            tap(
                data => {
                    this.artwork = new Artwork(data['data']['artwork']);
                    this.artworks.push(this.artwork);
                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    getSingleArtwork(projectId, databaseId, artworkId) {
        return this.http.get(this.getPath(projectId, databaseId) + '/' + artworkId).pipe(
            tap(
                data => {
                    this.artwork = new Artwork(data['data']['artwork']);

                    const index = this.artworks.findIndex(m => m["_id"] === data['data']['artwork']['_id']);

                    if (index > -1)
                        this.artworks[index] = this.artwork;
                    else
                        this.artworks.push(this.artwork);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    patchArtwork(projectId, databaseId,  artworkId, artwork: Artwork) {
        return this.http.patch(this.getPath(projectId, databaseId) +'/' + artworkId, artwork.getObj(false)).pipe(
            tap(
                data => {
                    this.artwork = new Artwork(data['data']['artwork']);

                    const index = this.artworks.findIndex(db => db["_id"] === artworkId);

                    if (index > -1)
                        this.artworks[index] = this.artwork;
                    else
                        this.artworks.push(this.artwork);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    deleteArtwork(projectId, databaseId, artworkId) {
        return this.http.delete(this.getPath(projectId, databaseId) + '/' + artworkId).pipe(
            tap(
                () => {
                    if (this.artwork._id === artworkId)
                        this.artwork = null;

                    this.artworks.splice(this.artworks.findIndex(m => m["_id"] === artworkId), 1);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    private patchGroupOrCategoryOrRoute(url, payload = {}) {
        return this.http.patch(url, payload).pipe(
            tap(
                data => {
                    this.artwork = new Artwork(data['data']['artwork']);

                    const index = this.artworks.findIndex(db => db["_id"] === this.artwork._id);

                    if (index > -1)
                        this.artworks[index] = this.artwork;
                    else
                        this.artworks.push(this.artwork);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    addGroup(projectId: string, databaseId: string, artworkId: string, groupId: string) {
        return this.patchGroupOrCategoryOrRoute(this.getPath(projectId, databaseId) + '/' + artworkId + '/groups/' + groupId + '/add');
    }
    removeGroup(projectId: string, databaseId: string, artworkId: string, groupId: string) {
        return this.patchGroupOrCategoryOrRoute(this.getPath(projectId, databaseId) + '/' + artworkId + '/groups/' + groupId + '/remove');
    }

    addRoute(projectId: string, databaseId: string, artworkId: string, routeId: string) {
        return this.patchGroupOrCategoryOrRoute(this.getPath(projectId, databaseId) + '/' + artworkId + '/routes/' + routeId + '/add');
    }
    removeRoute(projectId: string, databaseId: string, artworkId: string, routeId: string) {
        return this.patchGroupOrCategoryOrRoute(this.getPath(projectId, databaseId) + '/' + artworkId + '/routes/' + routeId + '/remove');
    }

    addCategory(projectId: string, databaseId: string, artworkId: string, categoryId: string, category: ArtworkCategory) {
        return this.patchGroupOrCategoryOrRoute(this.getPath(projectId, databaseId) +'/' + artworkId + '/categories/' + categoryId + '/add', category.getObj(true));

    }
    removeCategory(projectId: string, databaseId: string, artworkId: string, categoryId: string) {
        return this.patchGroupOrCategoryOrRoute(this.getPath(projectId, databaseId) +'/' + artworkId + '/categories/' + categoryId + '/remove');
    }

    private getPath(projectId, databaseId) {
        return '/api/v1/projects/' + projectId + '/databases/' + databaseId + '/artworks';
    }
}
